import React, { useState, useEffect } from 'react';

const ChevronLeft = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="1.5"
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

const ChevronRight = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="1.5"
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M9 18l6-6-6-6" />
  </svg>
);

const ExpertReviews = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const reviews = [
    {
      text: "The RUT956 industrial cellular router offers exceptional versatility with multiple interfaces and robust connectivity. Enhanced 4G LTE capabilities make it a standout for demanding industrial applications while ensuring reliable performance in various network conditions.",
      source: "TechReview"
    },
    {
      text: "RUT241 proves itself as a compact yet powerful networking solution. Its dual-SIM capability and automatic failover system ensure uninterrupted connectivity, making it an ideal choice for both business and industrial applications where network reliability is crucial.",
      source: "NetworkWorld"
    },
    {
      text: "The RUTm50 sets a new standard in 5G industrial routing. With its impressive 5 x Gigabit Ethernet ports and advanced security features, it's perfectly positioned for the future of industrial networking. The FCC certification adds an extra layer of credibility to this already impressive device.",
      source: "IndustrialTech Magazine"
    },
    {
      text: "RUT241 eSIM™ represents a significant step forward in cellular routing technology. The integration of eSIM technology alongside traditional features shows a clear understanding of where industrial connectivity is heading. The added TPM security makes it a compelling choice for security-conscious applications.",
      source: "Digital Industries Review"
    }
  ];

  const styles = {
    container: {
      padding: '40px 20px',
      maxWidth: '1200px',
      margin: '0 auto',
      textAlign: 'center'
    },
    heading: {
      fontSize: 'clamp(28px, 5vw, 50px)',  // Fluid typography
      color: '#410684',
      lineHeight: 'clamp(32px, 4vw, 40px)', // Responsive line height
      fontFamily: 'Oswald, sans-serif',
      marginBottom: '0px',
      fontWeight: '600',
      '@media (max-width: 1200px)': {
        fontSize: '42px',
        lineHeight: '36px'
      },
      '@media (max-width: 768px)': {
        fontSize: '34px',
        lineHeight: '38px'
      },
      '@media (max-width: 480px)': {
        fontSize: '28px',
        lineHeight: '30px'
      }
    },
    reviewContainer: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    review: {
      maxWidth: '900px',
      margin: '0 auto',
      opacity: 0,
      transition: 'opacity 0.5s ease',
      position: 'absolute',
      width: '100%'
    },
    activeReview: {
      opacity: 1,
      position: 'relative'
    },
    reviewText: {
      fontSize: '16px',
      lineHeight: '24px',
      color: '#414042',
      fontWeight:'400',
      marginTop:'25px',
      marginBottom: '25px',
      fontFamily:'Inter, sans-serif'
    },
    source: {
      fontSize: '16px',
      color: '#414042',
      fontStyle: 'italic'
    },
    navigationButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: '1px solid #E5E7EB',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#6B7280',
      transition: 'all 0.3s ease',
      padding: '8px'
    },
    prevButton: {
      left: 0
    },
    nextButton: {
      right: 0
    },
    navigationDots: {
      display: 'flex',
      justifyContent: 'center',
      gap: '8px',
      marginTop: '20px'
    },
    dot: {
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#ddd',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease'
    },
    activeDot: {
      backgroundColor: '#400684'
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % reviews.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  // Auto-advance slides
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>EXPERT INSIGHTS</h2>
      
      <div style={styles.reviewContainer}>
        <button 
          style={{...styles.navigationButton, ...styles.prevButton}}
          onClick={prevSlide}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#F3F4F6';
            e.currentTarget.style.color = '#374151';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#6B7280';
          }}
        >
          <ChevronLeft />
        </button>
        
        {reviews.map((review, index) => (
          <div
            key={index}
            style={{
              ...styles.review,
              ...(index === currentSlide ? styles.activeReview : {})
            }}
          >
            <p style={styles.reviewText}>{review.text}</p>
            <p style={styles.source}>- {review.source}</p>
          </div>
        ))}

        <button 
          style={{...styles.navigationButton, ...styles.nextButton}}
          onClick={nextSlide}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#F3F4F6';
            e.currentTarget.style.color = '#374151';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = '#6B7280';
          }}
        >
          <ChevronRight />
        </button>
      </div>

      <div style={styles.navigationDots}>
        {reviews.map((_, index) => (
          <div
            key={index}
            style={{
              ...styles.dot,
              ...(index === currentSlide ? styles.activeDot : {})
            }}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default ExpertReviews;